import { IkeDelayedTask } from '@ikegps/core-shared';
import { action, observable, reaction, makeObservable } from 'mobx';
import { ModalService } from '../components/modal/modal.service';
import { type IkeClientService, Services } from './index';

const SEARCH_DELAY = 200;

export class FilterState {
	@observable filter: string | null = null;

	constructor() {
		makeObservable(this);
	}

	@action setFilter(value: string) {
		this.filter = value;
	}

	hasFilter(): boolean {
		return this.filter != null && this.filter.trim().length > 0;
	}

	@action clear() {
		this.filter = null;
	}
}

export class MultiListSearchService implements IkeClientService {
	__priority = 100;

	inputfilterState: FilterState;
	filterState: FilterState;

	@observable filtering: boolean = false;

	searchTask: IkeDelayedTask;

	constructor(delay: number = SEARCH_DELAY) {
		makeObservable(this);

		this.inputfilterState = new FilterState();
		this.filterState = new FilterState();

		this.searchTask = new IkeDelayedTask(() => this.search(), delay);
	}

	init() {
		reaction(
			(_) => this.inputfilterState.filter,
			(_) => this.searchTask.delay()
		);
		reaction(
			(_) => Services.Department.current,
			(_) => this.reset()
		);
	}

	reset() {
		this.inputfilterState.clear();
		this.filterState.clear();
	}

	@action search(): void {
		if (!this.inputfilterState.hasFilter()) {
			this.filterState.setFilter(this.inputfilterState.filter);
			this.filtering = false;
			return;
		}

		this.filtering = true;
		ModalService.view();
		this.filtering = false;
	}
}
